import store from "~/js/store/store";
export default class Size {
  constructor() {
    this.contents = document.querySelector('._size');
    if(!this.contents)return;
    this.buttons = this.contents.querySelectorAll('._buttons');
    this.select = this.contents.querySelector('._select');
    this.inputs = this.contents.getElementsByTagName("input");
    this.opener = this.contents.querySelector('._opener');

    this.selectColorNum = "";
    this.selectSize = "";

    this.setup()
  }

  setup () {
    store.subscribe(((mutation, state) => {

      if(this.selectColorNum != store.getters['selectColorNum']())
      {
        this.selectColorNum = store.getters['selectColorNum']();

        this.buttons.forEach((elm, index) => {
          elm.classList.remove("on");
        });
        let selectColorButtons = this.contents.querySelector('._buttons[data-color="'+this.selectColorNum+'"]')
        selectColorButtons.classList.add("on");

        this.select.textContent = "";
        for(var i = 0; i <  this.inputs.length; i++)
        {
          this.inputs[i].checked = false;
        }

        //状態チェック
        /*store.dispatch('setButtonState', {
          sta: "out_of_stock"
        });
        const _inputs = selectColorButtons.getElementsByTagName("input");
        for(var i = 0; i <  _inputs.length; i++)
        {
          if(_inputs[i].dataset.state!="out_of_stock")
          {
            store.dispatch('setButtonState', {
              sta: "disabled"
            });
          }
        }*/
      }
    }));
		for(var i = 0; i <  this.inputs.length; i++)
    {
      this.inputs[i].addEventListener('change', (event) => {
        let target = event.currentTarget;
        store.dispatch('setSize', {
          num: target.value
        });

        /*switch(target.dataset.state)
        {
          case "in_stock" :
            store.dispatch('setButtonState', {
              sta: "in_stock"
            });
            break;
          case "arrival_notification" :
            store.dispatch('setButtonState', {
              sta: "arrival_notification"
            });
            break;
        }*/
      })
    }
    this.opener.addEventListener('click', (event) => {
      if( this.contents.classList.contains('open') == true ){
        this.contents.classList.remove("open");
      }
      else
      {
        this.contents.classList.add("open");
      }
    });
  }
}